import React from 'react';
import { getDaySmartBookingURL } from './DaySmartAppointmentBooking.utils';
var defaultProps = {
  width: '100%',
  height: '80vh',
  title: 'Book Appointment Now'
};
function DaySmartAppointmentBooking(_ref) {
  var guid = _ref.guid,
    width = _ref.width,
    height = _ref.height,
    title = _ref.title;
  if (!guid) {
    return null;
  }
  return /*#__PURE__*/React.createElement("iframe", {
    src: getDaySmartBookingURL(guid),
    title: title,
    scrolling: "yes",
    frameBorder: "0",
    style: {
      height: height,
      width: width
    }
  });
}
DaySmartAppointmentBooking.defaultProps = defaultProps;
export default DaySmartAppointmentBooking;